import { CustomConsole } from "custom-console-package";
export const logger = new CustomConsole(
  "https://api.cusorcart.com/api/error-endpoint"
);
